/**
 * Created by i.lovenkov on 21.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Slide: {
        displayName: 'Slide'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/Slider/default/Slide/Slide.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Slide = _wrapComponent('Slide')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(Slide, _Component);

    function Slide() {
        (0, _classCallCheck3.default)(this, Slide);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call(this));

        _this.handleOnLoadImg = function (e) {
            _this.setState({ imgLoad: true });
        };

        _this.clickChangeSlide = function () {
            var changeSlide = _this.props.changeSlide;

            changeSlide(_this.props.id);
        };

        _this.clickOnActiveSlide = function () {
            var clickOnActive = _this.props.clickOnActive;

            clickOnActive();
        };

        _this.state = { imgLoad: false };
        return _this;
    }

    (0, _createClass3.default)(Slide, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                src = _props.src,
                active = _props.active,
                firstImg = _props.firstImg,
                realImg = _props.realImg,
                slide = void 0;
            var imgLoad = this.state.imgLoad;


            if (type == 'big') {
                if (__SERVER__ && firstImg == realImg) {
                    slide = _react3.default.createElement(
                        'span',
                        { className: 'link' },
                        _react3.default.createElement(
                            'a',
                            { onClick: this.clickOnActiveSlide },
                            _react3.default.createElement('img', {
                                className: 'img-responsive flying-to-cart-img',
                                alt: '',
                                src: src
                            })
                        )
                    );
                } else {
                    slide = _react3.default.createElement(
                        'span',
                        { className: 'link' },
                        _react3.default.createElement(
                            'a',
                            { onClick: this.clickOnActiveSlide },
                            _react3.default.createElement('img', {
                                onLoad: this.handleOnLoadImg,
                                className: 'img-responsive flying-to-cart-img ' + (!imgLoad ? "hidden" : ""),
                                alt: '',
                                src: src
                            }),
                            _react3.default.createElement(_components2.Preloader, { preload: !imgLoad })
                        )
                    );
                }
            } else if (type == 'small') {
                slide = _react3.default.createElement(
                    'span',
                    null,
                    _react3.default.createElement(
                        'a',
                        { className: 'horizontal-thumb', onClick: this.clickChangeSlide },
                        _react3.default.createElement('img', { className: active ? "active" : "", width: '67', alt: '', src: src })
                    )
                );
            }

            return _react3.default.createElement(
                'span',
                { className: 'image_small_holder' },
                slide
            );
        }
    }]);
    return Slide;
}(_react2.Component), _class.propTypes = {
    type: _react2.PropTypes.string.isRequired,
    active: _react2.PropTypes.bool,
    id: _react2.PropTypes.number,
    src: _react2.PropTypes.string.isRequired,
    changeSlide: _react2.PropTypes.func,
    clickOnActive: _react2.PropTypes.func
}, _temp));

exports.default = Slide;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Slider/default/Slide/Slide.jsx
// module id = 1634
// module chunks = 0